const thousand = (num) => {
  if (num) {
    let num_parts = num.toString().split(",");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return num_parts.join(",");
  } else {
    return 0;
  }
};

const formatRupiah = (item) => {
  let val = item.setoran.replace(/\D/g, "");
  item.setoran = Number(val || 0).toLocaleString("id-ID");
};

// ================= FORMAT INPUT RUPIAH =================
const formatRupiahInput = (val) => {
  // handle null / clear
  if (val === null || val === undefined || val === "") {
    return "0";
  }

  // ambil angka saja
  let raw = String(val).replace(/\D/g, "");

  // format ke rupiah
  return Number(raw || 0).toLocaleString("id-ID");
};

// ================= SET ZERO (UNTUK CLEAR BUTTON) =================
const setZero = () => {
  return "0";
};

const thousandNumber = (num) => {
  const value = Number(num ?? 0);
  let num_parts = value.toString().split(".");
  num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return num_parts.join(",");
};

const thousandMask = (num) => {
  if (num) {
    let num_parts = num.toString().split(",");
    num_parts[0] = num_parts[0].replace(/\./g, "");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return [num_parts.join(",")];
  } else {
    return [0];
  }
};
const removeThousand = (num) => {
  if (num) {
    let num_parts = num.toString().split(",");
    num_parts[0] = num_parts[0].replace(/\./g, "");
    return num_parts.join(",");
  } else {
    return 0;
  }
};

const today = () => {
  const date = new Date();
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  let currentDate = `${day}/${month}/${year}`;
  return currentDate;
};

const formatDate = (dt, format = "YYYY-MM-DD") => {
  const date = new Date(dt);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  if (format === "DD-MM-YYYY") {
    return `${day < 10 ? "0" + day : day}/${
      month < 10 ? "0" + month : month
    }/${year}`;
  }

  return `${year}-${month < 10 ? "0" + month : month}-${
    day < 10 ? "0" + day : day
  }`;
};

const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

const truncateText = (text, maxLength) => {
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

const formatRibuan = (num) => {
  if (!num) return ["0"];
  let numStr = num.toString().replace(/\D/g, "");
  let num_parts = numStr.split(",");
  num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return num_parts;
};

export default {
  thousand,
  thousandMask,
  removeThousand,
  today,
  formatDate,
  fileToBase64,
  truncateText,
  formatRibuan,
  formatRupiah,
  formatRupiahInput,
  thousandNumber,
};
